<template>
  <h2 :class="$style.messageTitle">{{ title }}</h2>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';

@Component({
  props: {
    title: {
      type:    String,
      default: '',
    },
  },
})
export default class KioskMessageTitle extends Vue {}
</script>

<style lang="scss" module>
@import '@/style/variables.scss';

.messageTitle {
  color: $white;
  padding: 0 260px;
  font-size: 43px;
  line-height: 54px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/KioskMessageTitle.vue